import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class OrderStateRangesService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readOrderStateRange(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_ORDER_STATE_RANGE_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readOrderStateRanges(): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_ORDER_STATE_RANGE_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject('/order_state_ranges')
    );
  }
}
